function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getUser } from "../state/user";
import useTranslation from "../hooks/useTranslation";
var Context = /*#__PURE__*/ createContext({
    appcues: null,
    loading: false,
    error: null
});
export var useAppcues = function() {
    return useContext(Context);
};
export var Provider = function(param) {
    var children = param.children;
    var _useState = _slicedToArray(useState(null), 2), appcues = _useState[0], setAppcues = _useState[1];
    var user = useSelector(getUser);
    var language = useTranslation().language;
    var _useState1 = _slicedToArray(useState(false), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = _slicedToArray(useState(null), 2), error = _useState2[0], setError = _useState2[1];
    useEffect(function() {
        setLoading(true);
        setError(null);
        var timeout;
        // wait for Appcues to load
        var interval = setInterval(function() {
            if ("Appcues" in window) {
                clearInterval(interval);
                clearTimeout(timeout);
                setAppcues(window.Appcues);
                setLoading(false);
            }
        }, 300);
        // stop looking for Appcues if it cannot find it for a while
        timeout = setTimeout(function() {
            if (!("Appcues" in window)) {
                clearInterval(interval);
                setLoading(false);
                setError("Timedout loading Appcues");
            }
        }, 10000);
        return function() {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, []);
    // track user
    useEffect(function() {
        if (!appcues) {
            return;
        }
        if (user.id) {
            appcues.identify(user.id, {
                language: language,
                email: user.email
            });
        } else {
            appcues.reset();
        }
    }, [
        appcues,
        user,
        language
    ]);
    var value = useMemo(function() {
        return {
            appcues: appcues,
            loading: loading,
            error: error
        };
    }, [
        appcues,
        loading,
        error
    ]);
    return /*#__PURE__*/ React.createElement(Context.Provider, {
        value: value
    }, children);
};
Provider.propTypes = {
    children: PropTypes.node.isRequired
};
